import { Component } from "react"
import PropTypes from "prop-types"

import loadHeroImage from "shared/lib/load_hero_image"
import { partialStoryShape } from "app/lib/shared_prop_types"

class StoryCard extends Component {
  render() {
    const giveItTheBusiness = this.props.story.category === "Business" ? "/business" : ""
    const heroImage = loadHeroImage(this.props.story.hero_image, "rectangular")

    return (
      <div className="explore-tile">
        <a
          className="story-box"
          title={this.props.story.title}
          aria-label={this.props.story.title}
          ref={el => {
            this.scrollObserverEl = el
          }}
          href={`/${this.props.singleStoryBasePath}${giveItTheBusiness}/${this.props.story.slug}`}
        >
          <div className="top" style={{ background: `${this.props.story.card_background_color}64` }}>
            <div className="story-cta">
              <div className="category">
                <h5>{this.props.story.category}</h5>
              </div>
              <div className="title">
                <h4>{this.props.story.title}</h4>
              </div>
            </div>
          </div>
          <div className="middle" style={{ backgroundImage: `url(${heroImage})` }}></div>
          <div className="background" style={{ background: `${this.props.story.card_background_color}` }}></div>
        </a>
      </div>
    )
  }
}

StoryCard.propTypes = {
  story: partialStoryShape.isRequired,
  singleStoryBasePath: PropTypes.string.isRequired,
}

export default StoryCard
